var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoOptimisationSoluspots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.784,
    height: 109.852,
    viewBox: "0 0 117.784 109.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_933",
    "data-name": "Groupe 933",
    transform: "translate(-289.373 -1899.878)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 35.889,
    cy: 35.889,
    r: 35.889,
    transform: "translate(307.892 1918.916)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_921",
    "data-name": "Groupe 921",
    transform: "translate(289.373 1899.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5436",
    "data-name": "Trac\\xE9 5436",
    d: "M379.624,1922.946l-2.971,2.148c-.8-1.113-1.494-2.011-2.174-2.83a51.162,51.162,0,0,0-71.966-6.583l-2.346-2.817a54.829,54.829,0,0,1,77.13,7.056C378.033,1920.805,378.772,1921.767,379.624,1922.946Z",
    transform: "translate(-280.382 -1899.598)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5437",
    "data-name": "Trac\\xE9 5437",
    d: "M325.265,1991.673a54.759,54.759,0,0,1-31.019-73.856l3.345,1.5a51.093,51.093,0,0,0,28.939,68.912Z",
    transform: "translate(-289.373 -1884.934)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5438",
    "data-name": "Trac\\xE9 5438",
    d: "M360.485,1967.5a54.679,54.679,0,0,1-38.033,21.295l-.367-3.648a51.1,51.1,0,0,0,45.209-59.522l3.613-.62A55.032,55.032,0,0,1,360.485,1967.5Z",
    transform: "translate(-262.121 -1878.944)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5439",
    "data-name": "Trac\\xE9 5439",
    d: "M319.019,1965.03l-17.448,2.609-.541-3.626,12.319-1.843-5.843-11,3.236-1.721Z",
    transform: "translate(-279.661 -1858.58)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5440",
    "data-name": "Trac\\xE9 5440",
    d: "M362.871,1937.253,360,1939.537l-7.756-9.75-6.6,10.562-3.109-1.944,9.355-14.958Z",
    transform: "translate(-245.087 -1880.244)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5441",
    "data-name": "Trac\\xE9 5441",
    d: "M316.989,1916.916l-17.631-.623,6.465-16.415,3.412,1.344-4.566,11.59,12.45.441Z",
    transform: "translate(-281.055 -1899.878)",
    fill: "#41c850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_932",
    "data-name": "Groupe 932",
    transform: "translate(307.346 1930.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_497769936",
    "data-name": 497769936,
    d: "M321.082,1933.668a1.1,1.1,0,1,1,1.794-1.277l3.9,5.455a1.1,1.1,0,0,1-1.8,1.278l-3.9-5.455Z",
    transform: "translate(-281.101 -1903.951)",
    fill: "#101044"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_922",
    "data-name": "Groupe 922",
    transform: "translate(48.653 8.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5442",
    "data-name": "Trac\\xE9 5442",
    d: "M346.527,1948.465v-16.849l-8.126-9.932h-12.15v26.781",
    transform: "translate(-325.278 -1920.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5443",
    "data-name": "Trac\\xE9 5443",
    d: "M347.942,1948.906H346v-16.5l-7.613-9.307H327.667v25.808H325.72v-26.781a.972.972,0,0,1,.973-.971h12.15a.975.975,0,0,1,.753.356l8.124,9.931a.972.972,0,0,1,.222.616Z",
    transform: "translate(-325.72 -1921.154)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5444",
    "data-name": "Trac\\xE9 5444",
    d: "M340.165,1932.839H329.051a.972.972,0,0,1-.973-.971V1924.7a.972.972,0,0,1,.955-.972l6.214-.119a.989.989,0,0,1,.827.431l4.9,7.288a.971.971,0,0,1-.807,1.514Zm-10.141-1.943h8.315l-3.585-5.334-4.729.088Z",
    transform: "translate(-275.102 -1910.883)",
    fill: "#000f48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_923",
    "data-name": "Groupe 923",
    transform: "translate(4.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5445",
    "data-name": "Trac\\xE9 5445",
    d: "M342.641,1926.281a34.042,34.042,0,0,0-14.459-8.007,34.745,34.745,0,0,0-22.345,1.793l-3.465,12.428a35.048,35.048,0,0,0,13.741,10.4,35.445,35.445,0,0,0,21.39,1.793Q340.071,1935.483,342.641,1926.281Z",
    transform: "translate(-301.416 -1916.231)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5446",
    "data-name": "Trac\\xE9 5446",
    d: "M329.995,1946.949a35.611,35.611,0,0,1-13.816-2.744,36.07,36.07,0,0,1-14.118-10.677.963.963,0,0,1-.176-.854l3.466-12.426a.963.963,0,0,1,.541-.621,35.639,35.639,0,0,1,22.967-1.84,35.058,35.058,0,0,1,14.868,8.232.954.954,0,0,1,.268.957l-5.138,18.4a.951.951,0,0,1-.708.674A37.092,37.092,0,0,1,329.995,1946.949Zm-26.136-14.239a34.1,34.1,0,0,0,13.057,9.734,34.574,34.574,0,0,0,20.255,1.864L342,1927.024a33.1,33.1,0,0,0-13.625-7.391,33.66,33.66,0,0,0-21.3,1.569Z",
    transform: "translate(-301.85 -1916.665)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_924",
    "data-name": "Groupe 924",
    transform: "translate(5.433 23.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5447",
    "data-name": "Trac\\xE9 5447",
    d: "M302.567,1941.562l8.126-11.592",
    transform: "translate(-301.788 -1929.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 14.155,
    height: 1.91,
    transform: "translate(0 11.595) rotate(-54.999)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_925",
    "data-name": "Groupe 925",
    transform: "translate(28.2 29.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5448",
    "data-name": "Trac\\xE9 5448",
    d: "M315.083,1939.943v-7.169",
    transform: "translate(-314.128 -1932.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 1.91,
    height: 7.169,
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_926",
    "data-name": "Groupe 926",
    transform: "translate(40.047 28.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5449",
    "data-name": "Trac\\xE9 5449",
    d: "M321.471,1932.448l1.793,2.986",
    transform: "translate(-320.653 -1931.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 1.909,
    height: 3.484,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 0, 0.982)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_497769240",
    "data-name": 497769240,
    d: "M316.787,1944.755a1.106,1.106,0,0,1-1.351.768,1.082,1.082,0,0,1-.781-1.325l6.925-25.355a1.1,1.1,0,0,1,1.351-.766,1.08,1.08,0,0,1,.781,1.325l-6.925,25.353Zm-.367-27.1a1.1,1.1,0,0,1,1.351-.766,1.08,1.08,0,0,1,.781,1.325l-6.828,25a1.107,1.107,0,0,1-1.351.766,1.08,1.08,0,0,1-.781-1.325Z",
    transform: "translate(-290.534 -1916.51)",
    fill: "#101044"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_927",
    "data-name": "Groupe 927",
    transform: "translate(0 35.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5450",
    "data-name": "Trac\\xE9 5450",
    d: "M299.712,1936.4h69.895l.018,3.241-69.884-.162Z",
    transform: "translate(-298.733 -1935.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5451",
    "data-name": "Trac\\xE9 5451",
    d: "M370.07,1941.064h0l-69.886-.161a.977.977,0,0,1-.975-.968l-.029-3.08a.979.979,0,0,1,.979-.986h69.895a.976.976,0,0,1,.977.97l.02,3.243a.976.976,0,0,1-.979.982Zm-68.916-2.113,67.934.156-.009-1.283H301.143Z",
    transform: "translate(-299.178 -1935.869)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_928",
    "data-name": "Groupe 928",
    transform: "translate(17.918 32.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5452",
    "data-name": "Trac\\xE9 5452",
    d: "M318.825,1939.582a4.671,4.671,0,1,1-4.671-4.651A4.659,4.659,0,0,1,318.825,1939.582Z",
    transform: "translate(-308.511 -1933.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5453",
    "data-name": "Trac\\xE9 5453",
    d: "M314.6,1945.646a5.622,5.622,0,1,1,5.644-5.622A5.64,5.64,0,0,1,314.6,1945.646Zm0-9.3a3.677,3.677,0,1,0,3.7,3.677A3.692,3.692,0,0,0,314.6,1936.347Z",
    transform: "translate(-308.953 -1934.402)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_929",
    "data-name": "Groupe 929",
    transform: "translate(3.261 32.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5454",
    "data-name": "Trac\\xE9 5454",
    d: "M310.829,1939.625a4.671,4.671,0,1,1-4.671-4.651A4.661,4.661,0,0,1,310.829,1939.625Z",
    transform: "translate(-300.515 -1934.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5455",
    "data-name": "Trac\\xE9 5455",
    d: "M306.6,1945.689a5.622,5.622,0,1,1,5.644-5.622A5.638,5.638,0,0,1,306.6,1945.689Zm0-9.3a3.677,3.677,0,1,0,3.7,3.677A3.692,3.692,0,0,0,306.6,1936.39Z",
    transform: "translate(-300.957 -1934.445)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_930",
    "data-name": "Groupe 930",
    transform: "translate(51.377 32.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5456",
    "data-name": "Trac\\xE9 5456",
    d: "M337.079,1939.582a4.672,4.672,0,1,1-4.672-4.651A4.66,4.66,0,0,1,337.079,1939.582Z",
    transform: "translate(-326.764 -1933.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5457",
    "data-name": "Trac\\xE9 5457",
    d: "M332.848,1945.646a5.622,5.622,0,1,1,5.644-5.622A5.639,5.639,0,0,1,332.848,1945.646Zm0-9.3a3.677,3.677,0,1,0,3.7,3.677A3.692,3.692,0,0,0,332.848,1936.347Z",
    transform: "translate(-327.206 -1934.402)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_931",
    "data-name": "Groupe 931",
    transform: "translate(36.718 32.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5458",
    "data-name": "Trac\\xE9 5458",
    d: "M329.081,1939.625a4.671,4.671,0,1,1-4.671-4.651A4.661,4.661,0,0,1,329.081,1939.625Z",
    transform: "translate(-318.767 -1934.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5459",
    "data-name": "Trac\\xE9 5459",
    d: "M324.853,1945.689a5.622,5.622,0,1,1,5.644-5.622A5.639,5.639,0,0,1,324.853,1945.689Zm0-9.3a3.677,3.677,0,1,0,3.7,3.677A3.692,3.692,0,0,0,324.853,1936.39Z",
    transform: "translate(-319.209 -1934.445)",
    fill: "#000f48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoOptimisationSoluspots);
export default __webpack_public_path__ + "static/media/PICTO_OPTIMISATION_SOLUSPOTS.cf24df951b7fbc7fdbe48e86a24d310a.svg";
export { ForwardRef as ReactComponent };